//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { isValidColor } from "@Shared/@Utils/validation-rules";
import { Chrome } from "vue-color";
import { cloneDeep, debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Colorpicker",
  components: {
    MaterialInput,
    "chrome-picker": Chrome
  },
  mixins: [validationMixin],
  props: {
    color: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      default: "bottom"
    }
  },
  validations: {
    localColor: {
      required,
      isValidColor
    }
  },
  data() {
    return {
      colors: {
        hex: ""
      }
    };
  },
  computed: {
    localColor: {
      get() {
        return this.color;
      },
      set(value) {
        this.$emit("update:color", value);
      }
    }
  },
  watch: {
    color(value) {
      this.setValue(value);
    },
    colors(value) {
      this.localColor = value.hex;
      this.handleChange(cloneDeep(value.hex));
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    setValue: debounce(function (value) {
      this.colors.hex = value;
    }, 150),
    init() {
      this.colors.hex = this.color;
    },
    hidePicker() {
      this.$refs.colorPickerPopover.$emit("hide");
    },
    handleChangeColorFromInput: debounce(function (value) {
      this.colors = {
        hex: value
      };
    }, 150),
    handleChange(value) {
      this.$emit("change", value);
    },
    getPopoverTarget() {
      return this.$refs.colorPickerTarget;
    }
  }
});